module.exports = __webpack_public_path__ + "wxMicroService/img/bg.d4722e3c.png";